








import { Component, Vue, Emit } from 'vue-property-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { ALL_PROJECTS } from '@/queries/Project';
import ProjectForm from '@/components/Project/ProjectForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_createProject, GQL_createProjectVariables } from '@/queries/__generated__/createProject';
import { GQL_currentUnitProjects } from '@/queries/__generated__/currentUnitProjects';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';

import { SmartQuery } from 'vue-apollo-decorator';
import gql from 'graphql-tag';

const CREATE_PROJECT = gql`
  mutation createProject(
    $unitId: ID!,
    $code: String!,
    $name: String!,
  ) {
    createProject(
      input: {
        project: {
          unitId: $unitId,
          code: $code,
          name: $name,
        }
      }
    ) {
      project {
        id
        code
        name
      }
    }
  },
`;

@Component({
  components: {
    ProjectForm,
  },
})
export default class ProjectNew extends Vue {
  public CREATE_PROJECT = CREATE_PROJECT;
  public currentUnitId: string | null = null;

  @SmartQuery<ProjectNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) public currentUnit!: GQL_currentUnit_currentUnit;

  public data: GQL_createProjectVariables = {
    unitId: '',
    code: '',
    name: '',
  };

  @Emit('project-created')
  public addToCache(store: InMemoryCache, query: {data: GQL_createProject }) {
    const data = (store.readQuery({ query: ALL_PROJECTS }) as GQL_currentUnitProjects);
    if (!data.currentUnit || !query.data.createProject || !query.data.createProject.project) return;
    const project = query.data.createProject.project;
    data.currentUnit.projects.push(project);
    store.writeQuery({ query: ALL_PROJECTS, data });
    return project;
  }
}
